export default __webpack_public_path__ + "static/model360-oslo-dae9b2c7a43b010e8559086fc8e43b95.png";